/* eslint-disable no-unused-vars */
import { api } from '../api';
import { useApiMutation, useApiQuery, useApiQueryWithPagination } from './query';

const getRoleId = (role) => role.id;

const getRoleIds = (roles) => (roles ? roles.map(getRoleId) : []);

export const useUser = (user) => {
  const { samAccountName } = user;
  const fetchRoles = () => useApiQuery(['roles', samAccountName], api.fetchUserRoles);
  const [apiEditUserRoles] = useApiMutation(api.editUserRoles);

  const updateUserRole = (updatedUser) =>
    apiEditUserRoles({
      samAccountName,
      roleIds: getRoleIds(updatedUser.roles),
    });

  return {
    fetchRoles,
    updateUserRole,
  };
};

export const useUsers = (initialUsers, options = {}) => {
  const {
    data: users,
    isFetching,
    paginationMeta,
  } = useApiQueryWithPagination(['users', { options }], api.fetchUsers, { page: 1, size: 5 });

  return {
    users: users || initialUsers,
    isFetching,
    paginationMeta,
  };
};
